<template>
	<div id="top-bar">
		<h1 class="text-white">
      MISIÓN
		</h1>
	</div>
</template>

<script>

export default {
	name: 'main-menu'
};
</script>



// WEBPACK FOOTER //
// TopBar.vue?39207492